import * as types from './actionTypes';

export const updateNetworkQuality = (quality, stats) => ({
  type: types.NETWORK_QUALITY_UPDATE,
  payload: { quality, stats }
});

export const showNetworkQualityToast = (text, quality) => ({
  type: types.NETWORK_QUALITY_TOAST_SHOW,
  payload: { text, quality, at: Date.now() }
});

export const clearNetworkQualityToast = () => ({
  type: types.NETWORK_QUALITY_TOAST_CLEAR
});

export default {
  updateNetworkQuality,
  showNetworkQualityToast,
  clearNetworkQualityToast
};
